
// SVG Icon: controls
export default { id: "terriajs-controls" };
export const id = "terriajs-controls";
export const name = "controls";
